import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { bootstrapBriefcase, bootstrapGeoAltFill, bootstrapGlobe2, bootstrapHeartFill } from '@ng-icons/bootstrap-icons';
import { BrowserService } from 'src/app/core/browser.service';

@Component({
    selector: 'app-jobs-skeleton',
    templateUrl: './jobs-skeleton.component.html',
    styleUrl: './jobs-skeleton.component.scss',
    imports: [NgFor, NgIcon],
    providers: [
        provideIcons({ bootstrapHeartFill,
            bootstrapGeoAltFill,
            bootstrapBriefcase,
            bootstrapGlobe2 })
    ]
})
export class JobsSkeletonComponent {
  resultsInGrid: boolean = true;


  constructor(private browserService: BrowserService) {}

  ngOnInit(): void {
    if (this.browserService.localStorageGetItem('jobs-in-grid') === 'false') {
      this.resultsInGrid = false;
    }
  }
}
